
<template>
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title"> Người Liên Quan </h4>
      </div>
      <div class="modal-body">
        <!-- full_name -->
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.full_name`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('customer.relatives.full_name')" v-model="related_resident.full_name" id="full_name" @input="validateFieldIsEmpty('full_name')">
              <span v-if="related_resident.full_name == '' || related_resident.full_name == null && resident_full_name == true" class="help is-danger">
                <font color="red">{{$t('customer.relatives.full_nameValidate')}}</font>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.gender`)}}</label>
              <select v-model="related_resident.gender" class="form-control">
                <option
                    v-for="gender in gender_list"
                    v-bind:value="gender.id"
                    :key="gender.id"
                >{{ $t(gender.text) }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.identification_number`)}}</label>
              <input type="number" class="form-control" :placeholder="$t('customer.relatives.identification_number')" v-model="related_resident.identification_number">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.passport`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('customer.relatives.passport')" v-model="related_resident.passport">
            </div>
          </div>
           <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.phone_number`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('customer.relatives.phone_number')" v-model="related_resident.phone_number">
              <span v-if="related_resident.phone_number == '' || related_resident.phone_number == null && resident_phone_number == true" class="help is-danger">
                <font color="red">{{$t('customer.relatives.full_nameValidate')}}</font>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.resident_contract`)}}</label>
              <select v-model="related_resident.resident_contract" class="form-control">
                <option
                    v-for="contract in contracts"
                    v-bind:value="contract.value"
                    :key="contract.value"
                >{{ $t(contract.text) }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`customer.relatives.resident_type`)}}</label>
              <select v-model="related_resident.resident_type" class="form-control">
                <option
                    v-for="resident_type in resident_types"
                    v-bind:value="resident_type.value"
                    :key="resident_type.value"
                >{{ $t(`customer.related_resident_types.${resident_type.text}`) }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.back')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-if="!!id"
          @click="onSave"
        >{{$t('common.save')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-else
          @click="onAdd"
        >{{$t('common.add')}}</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex"
import constantsData from '@/lib/constantsData'
import ResidentContractEnum from "@/enum/residentContractEnum";
// import utils from '@/lib/utils';


export default {
  name: "RelatedResidentsInputView",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      contracts: [
        {
          value: ResidentContractEnum.FULLTIME,
          text: "customer.contract.fulltime"
        },
        {
          value: ResidentContractEnum.PARTTIME,
          text: "customer.contract.parttime"
        }
      ],
      resident_types: [
        {
          value: 2,
          text: "housekeeper"
        },
        {
          value: 3,
          text: "driver"
        }
      ],
      gender_list: constantsData.genderTypes,
      related_resident: {
        full_name: null,
        relationship: null,
        yob: null,
        gender: 1,
        nationality: 287,
        phone_number: null,
        notes: null,
        identification_number: null,
        passport: null,
        resident_contract: ResidentContractEnum.FULLTIME,
        resident_type: 2,
      },
      field_required:{
          'full_name':'',
          'phone_number':''
        },
      resident_full_name:false,
      resident_phone_number:false
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.GET_RELATIVE_DETAIL({id:this.id}).then(
          function(res) {
            let relative_data = res
            this.related_resident.full_name = relative_data.full_name
            this.related_resident.relationship = relative_data.relationship
            this.related_resident.yob = relative_data.yob
            this.related_resident.gender = relative_data.gender
            this.related_resident.nationality = relative_data.nationality
            this.related_resident.phone_number = relative_data.phone_number
            this.related_resident.notes = relative_data.notes
            this.related_resident.identification_number = relative_data.identification_number
            this.related_resident.passport = relative_data.passport
            this.related_resident.resident_contract = relative_data.resident_contract
            this.related_resident.resident_type = relative_data.resident_type
          }.bind(this)
        )
      } else {
        this.reset()
      }
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
    ...mapActions([
      "GET_COUNTRY_LIST",
      "GET_RELATIVE_DETAIL"
    ]),
    reset: function() {
      this.related_resident.full_name = null
      this.related_resident.relationship = null
      this.related_resident.yob = null
      this.related_resident.gender = 1
      this.related_resident.nationality = 287
      this.related_resident.phone_number = null
      this.related_resident.identification_number = null
      this.related_resident.passport = null
      this.related_resident.notes = null
      this.related_resident.resident_contract = ResidentContractEnum.FULLTIME,
      this.related_resident.resident_type = 2
    },
    onAdd: function() {
      if(this.related_resident.full_name === null || this.related_resident.full_name === ""){
        this.resident_full_name=true
      }else if(this.related_resident.phone_number === null || this.related_resident.phone_number === ""){
        this.resident_phone_number=true
      }      
      else
      {
        const saveRelative = {
          full_name: this.related_resident.full_name,
          relationship: this.related_resident.relationship,
          yob: this.related_resident.yob,
          gender: this.related_resident.gender,
          nationality: this.related_resident.nationality,
          phone_number: this.related_resident.phone_number,
          identification_number: this.related_resident.identification_number,
          passport: this.related_resident.passport,
          resident_contract: this.related_resident.resident_contract,
          resident_type: this.related_resident.resident_type,
          notes: this.related_resident.notes
        }
        this.$emit("related_resident-add", saveRelative)
      }
    },
    onSave: function() {
      if(this.related_resident.full_name === null || this.related_resident.full_name === ""){
        this.resident_full_name=true
      }
      else
      {
        const id = this.id
        const saveRelative = {
          full_name: this.related_resident.full_name,
          relationship: this.related_resident.relationship,
          yob: this.related_resident.yob,
          gender: this.related_resident.gender,
          nationality: this.related_resident.nationality,
          phone_number: this.related_resident.phone_number,
          identification_number: this.related_resident.identification_number,
          passport: this.related_resident.passport,
          resident_contract: this.related_resident.resident_contract,
          resident_type: this.related_resident.resident_type,
          notes: this.related_resident.notes
        }
        this.$emit("related_resident-save", id, saveRelative)
      }
    },
    validateFieldIsEmpty: function(field, objectName = 'this.related_resident.',  objectNameRequire = 'this.field_required.' ) {

            // use for get value : this.userdata.last_name
            let exec = objectName + field

            // this.field_required.last_name
            let error_msg = objectNameRequire + field

            // Init data befor check
            eval(error_msg + " = ''")

            // ==> get value current
            let result = eval(exec)

            if (result == null || result == "") {
                eval(error_msg + " = 'common.error_msg[0].required'")
            }

            return result;
    },
  },
  mounted() {
    this.GET_COUNTRY_LIST().then(
      function(res) {
        let countries = []
        let data = res.data
        data.forEach(c => {
          let country = {
            value: c.id,
            text: c.country_name
          }
          countries.push(country)
        })
        this.country_list = countries
      }.bind(this)
    )
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Customer/RelatedResidentsInputView.vue